export const iconFontAwesomeDesignObjectUngroup = (
	<i className="fa-solid fa-object-ungroup"></i>
);
